<app-uni-page
  [parent]="this"
  pageTitle="References: Manufacturer Product Configs"
  [bodyTemplate]="bodyTemplate"
  [footerTemplate]="footerTemplate"
>
</app-uni-page>
<ng-template #bodyTemplate>
  <div class="flex flex-col h-full">
    <div class="qb-list-actions">
      <button
        pButton
        type="button"
        class="p-button-raised p-button-sm"
        icon="pi pi-plus"
        [disabled]="!this.user.isProductAdmin"
        (click)="addMptConfig()"
      >
        <span>Add Manufacturer Product Type Configuration</span>
      </button>
    </div>
    <app-ag-grid [gridOptions]="mptConfigGridOptions" class="flex-1 min-h-0"></app-ag-grid>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
